const numberFormat = (number) => {
  // split number from float part
  number = number.toString().replace(/^0+/, ''); // remove 0 from the start of the number
  // remove special characters from the number
  let lastThree = number.substring(number.length - 3); // get the last 3 digits
  let restNumber = number.substring(0, number.length - 3); // rest of the number
  if (restNumber !== '') {
    lastThree = ',' + lastThree;
  }
  return restNumber.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
};

export default numberFormat;
